import React from 'react';

export default function ChevronUp({ ...other }) {
  return (
    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.4414 6.96582L6.3147 1.95703L5.3429 0.777588L4.37115 1.95703L0.244385 6.96582H2.18799L5.3429 3.13647L8.49786 6.96582H10.4414Z" fill="black" />
    </svg>
  );
}
